import React, { useEffect, useState } from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, Typography, Box
} from '@mui/material';
import SickIcon from '@mui/icons-material/Sick';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getAccessToken } from '../../utils/auth';

const ProfilePage = () => {
  const [registrations, setRegistrations] = useState([]);
  const [error, setError] = useState('');
  const [userInfo, setUserInfo] = useState({ username: '', name: '', mobile_number: '' });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Fetch data from API
  const fetchRegistrations = async () => {
    try {
      const token = await getAccessToken();
      const response = await fetch('https://app.recyconelement.dk/api/time/get_time_registrations.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setRegistrations(result.data);
      } else {
        setError('Fejl: ' + result.message);
      }
    } catch (error) {
      console.error('Fejl ved hentning af tidsregistreringer:', error);
      setError('Der opstod en fejl. Prøv igen senere.');
    }
  };

  const fetchUserInfo = async () => {
    try {
      const token = await getAccessToken();
      const response = await fetch('https://app.recyconelement.dk/api/user/getUser.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setUserInfo(result.data);
      } else {
        setError('Fejl: ' + result.message);
      }
    } catch (error) {
      console.error('Fejl ved hentning af brugeroplysninger:', error);
      setError('Der opstod en fejl. Prøv igen senere.');
    }
  };

  useEffect(() => {
    fetchRegistrations();
	fetchUserInfo();
  }, []);


  return (
    <div>
      <Box mb={3} p={2} component={Paper}>
        <Typography variant="h6">Brugeroplysninger</Typography>
        <Typography>Brugernavn: {userInfo.username}</Typography>
        <Typography>Navn: {userInfo.name}</Typography>
        <Typography>Mobiltelefonnummer: {userInfo.mobile_number}</Typography>
      </Box>

      <Typography variant="h4" gutterBottom>
        Tidsregistreringer
      </Typography>

      {error && <Typography color="error">{error}</Typography>}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Dato</TableCell>
              <TableCell>Starttid</TableCell>
              <TableCell>Sluttid</TableCell>
              <TableCell>Fravær</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {registrations.map((registration) => (
              <TableRow key={registration.id}>
                <TableCell>{registration.date}</TableCell>
                <TableCell>
                  {registration.start_time ? registration.start_time.slice(0, 5) : ''}
                </TableCell>
                <TableCell>
                  {registration.end_time ? registration.end_time.slice(0, 5) : ''}
                </TableCell>
                <TableCell>
                  {registration.type === '51' ? <SickIcon color="error" /> : ''}
                  {registration.type === '60' ? <BeachAccessIcon color="primary" /> : ''}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ProfilePage;
